export default "__VITE_ASSET__32055d32__"